import { useSession } from "./useSession"

export const useOrganization = () => {
  const { user } = useSession()
  return user?.organization
}
